import * as React from 'react';
import Keyicon from '@keaze/web/public/svg/key-icon.svg';
import { Box} from '@mui/system';
import styled from 'styled-components';

import {
  Selling,
  SellingContent,
  MainContainer,
  SellingButton

    
  } from '../styles/selling.styles'
import {StaircasedButton} from "@keaze/web/views/PostSalesGuide/styles/staircase.styles";
  
  const S = {

    SellingImageContainer: styled(Box)`
    ${({ theme: { breakpoints} }) => ` 
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 0 0 120px 0;
    bottom: 0;
    top: 0px;
    position: relative;
    left: -16px;
    height: 250px;
    margin-bottom: -200px;
    padding-bottom:30px;
    margin-top:20px;

${breakpoints.up('md')} {
        left: unset;
        width: 451px !important;
        height: 657px;
        position: absolute;
        z-index: 2;
        right: -40%;
        top: 80px;
        width: 80%;  
    }
`}
  `,
   }

type Props = {
    data: Record<string, never>
};

const SellingComponent = (props: Props) => {
    return (
        <MainContainer>
            <Selling>
                <SellingContent>
                    <Keyicon/>
                    <h2>{props.data.title ?? 'Selling your shared ownership home'}</h2>
                    <div dangerouslySetInnerHTML={{__html: props.data.content ?? ''}}></div>

                    {!!props.data.file && (
                        <a href={props.data.file} target="_blank">
                            <SellingButton variant="outlined">
                                Download Guide
                            </SellingButton>
                        </a>
                    )}
                </SellingContent>
                <S.SellingImageContainer sx={{
                    backgroundImage: `url(${props.data.image ?? 'images/HomeStepper/PostSalesGuideImgOrange.png'})`
                }} />
            </Selling>
        </MainContainer>
)}

export default SellingComponent;